<div *transloco="let t; prefix: 'project'" data-testid="step-1-3-project-settings">
  @if (isLoading()) {
    <app-loading />
  } @else {
    <p-tabs appTabsUnsavedReveal [value]="0" data-testid="step-1-3-tabs" scrollable>
      <p-tablist data-testid="step-1-3-tablist">
        <p-tab [value]="0" data-testid="importance-scale-tab" [appTabStatus]="tabStatuses().scale">
          1.3.1 {{ t('steps.importanceScale') }}
        </p-tab>
        <p-tab
          [value]="1"
          data-testid="normalization-range-tab"
          [appTabStatus]="tabStatuses().normalization"
        >
          1.3.2 {{ t('steps.normalizationRange') }}
        </p-tab>
        <p-tab
          [value]="2"
          data-testid="hosting-provider-tab"
          [appTabStatus]="tabStatuses().hostingProvider"
        >
          1.3.3 {{ t('steps.hostingProviderLocation') }}
        </p-tab>
        <p-tab
          [value]="3"
          data-testid="project-language-tab"
          [appTabStatus]="tabStatuses().projectLanguage"
        >
          1.3.4 {{ t('steps.projectLanguage') }}
        </p-tab>
      </p-tablist>

      <p-tabpanels class="mt-6" data-testid="step-1-3-tabpanels">
        <p-tabpanel [value]="0" data-testid="importance-scale-tabpanel">
          <app-importance-scale-tab
            [selectedScale]="selectedScale()"
            [originalScale]="originalScale()"
            [isSaving]="isSaving()"
            [disabled]="isButtonDisabled()"
            (scaleChange)="onScaleChange($event)"
            (submitOutput)="onSubmitScale()"
          ></app-importance-scale-tab>
        </p-tabpanel>

        <p-tabpanel [value]="1" data-testid="normalization-range-tabpanel">
          <app-normalization-range-tab
            [originalValues]="originalNormalizationValues()"
            [isSaving]="isSaving()"
            [disabled]="isButtonDisabled()"
            (submitOutput)="onSubmitNormalizationRange($event)"
          ></app-normalization-range-tab>
        </p-tabpanel>

        <p-tabpanel [value]="2" data-testid="hosting-provider-tabpanel">
          <app-hosting-provider-tab
            [originalLocation]="originalHostingLocation()"
            [isSaving]="isSaving()"
            [disabled]="isButtonDisabled()"
            (submitOutput)="onSubmitHostingLocation($event)"
          ></app-hosting-provider-tab>
        </p-tabpanel>

        <p-tabpanel [value]="3" data-testid="project-language-tabpanel">
          <app-project-language-tab
            [originalLanguage]="originalProjectLanguage()"
            [isSaving]="isSaving()"
            [disabled]="isButtonDisabled()"
            (submitOutput)="onSubmitProjectLanguage($event)"
          ></app-project-language-tab>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  }
</div>
